import { ReactElement } from 'react';

export type Interface = {
	children: string;
	className: string;
};

export const Text = ({ className, children }: Interface): ReactElement => <span className={className}>{children}</span>;
